// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @20.11.2018 09:54:26
import { CrisisCardCreateArgs_abstract } from './../../abstract/SagaBase/Defines/CrisisCardCreateArgs_abstract';
export class CrisisCardCreateArgs extends CrisisCardCreateArgs_abstract {}
